import React, { useEffect } from 'react';

const Button = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: Button is not implemented yet.');
  }, []);
  return (
    <>
  { /*Button */} 
 </>
  );
};

export default Button;
